module.exports = __webpack_public_path__ + "img/c8219403ab24c589d4b8587981ef58c.ad8c6204.png";